import { SET_PAGE_INFO } from './types';

export const send = (settings) => dispatch => {
  dispatch({
    type: SET_PAGE_INFO,
    payload: settings
  });
};
